(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odyss-brand-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var trigger = event.target.closest && event.target.closest('[data-odyss-cookie-preferences]');
    if (!trigger) return;
    event.preventDefault();
    if (window.OdyssConsent && typeof window.OdyssConsent.openPreferences === 'function') {
      window.OdyssConsent.openPreferences();
    }
  });

  function updateIcpFilingVisibility() {
    const language = (navigator.language || '').toLowerCase();
    const showFiling = /^zh-(?:cn|sg|tw|hant-tw|hans(?:-[a-z0-9]+)*)$/.test(language);

    document.querySelectorAll('[data-ga-button="icp_filing"]').forEach((link) => {
      link.hidden = !showFiling;
    });
  }

  updateIcpFilingVisibility();
  document.addEventListener('shopify:section:load', updateIcpFilingVisibility);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odyss-support-center-footer"]) return;
  try {
    
  if (!customElements.get('odyss-support-footer')) {
    customElements.define('odyss-support-footer', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const dialog = this.querySelector('dialog');
        const trigger = this.querySelector('[data-newsletter-open]');
        trigger.hidden = false;
        trigger.addEventListener('click', () => {
          dialog.showModal();
          trigger.setAttribute('aria-expanded', 'true');
        }, { signal });
        this.querySelector('[data-newsletter-close]').addEventListener('click', () => dialog.close(), { signal });
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }, { signal });
        dialog.addEventListener('close', () => {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus({ preventScroll: true });
        }, { signal });
        const preferences = this.querySelector('[data-cookie-preferences]');
        if (window.OdyssConsent?.openPreferences) {
          preferences.hidden = false;
          preferences.addEventListener('click', () => window.OdyssConsent.openPreferences(), { signal });
        }
        const initLogo = () => {
          if (!this.isConnected || signal.aborted || this.animation || !window.lottie || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          const logo = this.querySelector('.opre-wordmark--lottie');
          const player = logo.querySelector('[data-support-lottie-player]');
          const animation = window.lottie.loadAnimation({
            container: player,
            renderer: 'svg',
            loop: false,
            autoplay: false,
            path: logo.dataset.lottiePath
          });
          this.animation = animation;
          animation.addEventListener('DOMLoaded', () => {
            if (signal.aborted) return;
            logo.querySelector('.osc-footer-logo').setAttribute('hidden', '');
            player.hidden = false;
            if (!('IntersectionObserver' in window)) {
              animation.goToAndPlay(0, true);
              return;
            }
            this.observer = new IntersectionObserver((entries) => {
              if (!entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .35)) return;
              animation.goToAndPlay(0, true);
              this.observer.disconnect();
            }, { threshold: .35 });
            this.observer.observe(logo);
          });
        };
        if (window.lottie) initLogo();
        else document.querySelector('[data-support-lottie-library]')?.addEventListener('load', initLogo, { once: true, signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.animation?.destroy();
        this.animation = null;
        this.querySelector('.osc-footer-logo').removeAttribute('hidden');
        this.querySelector('[data-support-lottie-player]').hidden = true;
        this.querySelector('dialog')?.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
